import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import * as Api from 'api';
import Dropzone from 'react-dropzone';
import unkinkPolygon from '@turf/unkink-polygon';
import { polygon } from '@turf/helpers';
import simplify from '@turf/simplify';
import ToGeoJson from '@mapbox/togeojson';

class MapCreatorKMLUpload extends React.Component {
  constructor(props) {
    super(props);

    this.handleDropKML = this.handleDropKML.bind(this);
    this.handleRemoveKMLLayer = this.handleRemoveKMLLayer.bind(this);
  }

  handleDropKML(map_id, accepted_files, rejected_files) {
    this.props.uploadKMLLayers(map_id, accepted_files, rejected_files);
  }
  handleRemoveKMLLayer(file_id, map_id) {
    this.props.removeKMLLayer(file_id, map_id);
  }

  render() {
    const {
      hidden_kml_layers,
      deleting_kml_layer,
      uploading_kml_layers
    } = this.props.mapCreator;
    const { map } = this.props;

    return (
      <div>
        <h5>KML Layers</h5>
        <hr className='mt-none mb-lg' />
        <ul className='list-unstyled mb-sm'>
        {(map.properties.kml_layers || []).map(file => {
          const hidden = (hidden_kml_layers || []).includes(file._id);
          return (
            <li key={file._id}>
              <span>{file.originalName}</span>
              <i className='fa fa-arrow-down'></i>
              <i className='fa fa-arrow-up'></i>
              <span className='pull-right light-bg'>
                <i
                  onClick={() => this.handleRemoveKMLLayer(file._id, map._id)}
                  className='text-danger fa fa-trash pl-xs'
                />
                <i
                  onClick={() => this.props.toggleHideKMLLayer(file._id)}
                  className={`pl-xs ${hidden ? 'fa fa-eye-slash' : 'fa fa-eye'}`}
                />
              </span>
            </li>
          );
        })}
        </ul>
        {!deleting_kml_layer && !uploading_kml_layers ? (
          <Dropzone
            style={{height: 100}}
            onDrop={(...args) => this.handleDropKML(map._id, ...args)}
            >
            <div className='alert alert-info p-xs'>
              <p className='text-center'><i className='fa fa-plus fa-2x'></i></p>
              <p>Drag and drop a KML here to add it as a layer.</p>
            </div>
          </Dropzone>
        ) : (
          <div className='alert alert-info p-xs'>
            <p className='text-center'><i className='fa fa-spinner fa-spin fa-2x' /></p>
            <p>Processing ...</p>
          </div>
        )}
      </div>
    );
  }
}

export default mapCreatorConnect(MapCreatorKMLUpload);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-kml-upload.js